import React from "react";
import { Link } from "react-router-dom";
import ScrollAnimation from "../components/ScrollAnimation";
import "./Corporate.css";

const Corporate = () => {
  const certifications = [
    {
      name: "ISO 9001:2015",
      description: "Kalite Yönetim Sistemi",
      icon: "🏆",
    },
    {
      name: "ISO 14001:2015",
      description: "Çevre Yönetim Sistemi",
      icon: "🌱",
    },
    {
      name: "OHSAS 18001",
      description: "İş Sağlığı ve Güvenliği",
      icon: "🛡️",
    },
    {
      name: "CE Belgesi",
      description: "Avrupa Uygunluk İşareti",
      icon: "✅",
    },
  ];

  const clients = [
    { name: "Otomotiv Sanayi", logo: "🚗" },
    { name: "Savunma Sanayi", logo: "🛡️" },
    { name: "Teknoloji", logo: "💻" },
    { name: "Gıda Sektörü", logo: "🍞" },
    { name: "Kimya Sanayi", logo: "🧪" },
    { name: "İnşaat Sektörü", logo: "🏗️" },
    { name: "Enerji Sektörü", logo: "⚡" },
  ];

  const references = [
    { name: "ASELSAN", sector: "Savunma Sanayi", initials: "AS" },
    { name: "CENGİZ İNŞAAT", sector: "İnşaat", initials: "CI" },
    { name: "MKE", sector: "Savunma Sanayi", initials: "MK" },
    { name: "TK LAZER", sector: "Teknoloji", initials: "TL" },
    { name: "TEKATRON A.Ş", sector: "Elektronik", initials: "TA" },
    {
      name: "GİPS GELİŞTİRİLMİŞ İNŞ.MALZEMELERİ",
      sector: "İnşaat Malzemeleri",
      initials: "GG",
    },
    { name: "ÖZBARAN OFSET", sector: "Matbaacılık", initials: "ÖO" },
    { name: "NISSHIN SEİFUN", sector: "Gıda", initials: "NS" },
    { name: "KALEKİM", sector: "Kimya", initials: "KK" },
    { name: "YİĞİT AKÜ", sector: "Otomotiv", initials: "YA" },
    { name: "T KALIP", sector: "Kalıp İmalat", initials: "TK" },
    { name: "CENTURION İLAÇ", sector: "İlaç", initials: "CI" },
    { name: "İŞ BİR", sector: "Sanayi", initials: "İB" },
    { name: "HACETTEPE HASTANESİ", sector: "Sağlık", initials: "HH" },
  ];

  return (
    <div className="corporate-page">
      <div className="corporate-hero">
        <div className="container">
          <h1 className="page-title">Kurumsal</h1>
          <p className="page-subtitle">
            RPM Kompresör'ün kurumsal yapısı, hizmetleri ve sektördeki konumu
            hakkında detaylı bilgiler
          </p>
        </div>
      </div>

      <div className="corporate-content">
        <div className="container">
          {/*
          <section className="certifications-section">
            <h2 className="section-title">Sertifikalarımız</h2>
            <p className="section-subtitle">
              Uluslararası standartlarda kalite, çevre ve güvenlik
              sertifikalarımızla müşterilerimize güvenilir hizmet sunuyoruz.
            </p>
            <div className="certifications-grid">
              {certifications.map((cert, index) => (
                <ScrollAnimation key={index} direction="up" delay={index * 100}>
                  <div className="cert-card">
                    <div className="cert-icon">{cert.icon}</div>
                    <h3 className="cert-name">{cert.name}</h3>
                    <p className="cert-description">{cert.description}</p>
                  </div>
                </ScrollAnimation>
              ))}
            </div>
          </section>
          */}

          <section className="clients-section">
            <h2 className="section-title">Müşteri Sektörlerimiz</h2>
            <p className="section-subtitle">
              Farklı sektörlerden müşterilerimize hizmet veriyoruz. Her sektörün
              özel ihtiyaçlarına uygun çözümler sunuyoruz.
            </p>
            <div className="clients-grid">
              {clients.map((client, index) => (
                <ScrollAnimation
                  key={index}
                  direction="right"
                  delay={index * 100}
                >
                  <div className="client-card">
                    <div className="client-logo">{client.logo}</div>
                    <h3 className="client-name">{client.name}</h3>
                  </div>
                </ScrollAnimation>
              ))}
            </div>
          </section>

          <section className="references-section">
            <h2 className="section-title">Referanslarımız</h2>
            <p className="section-subtitle">
              Güvenilir hizmetimizle farklı sektörlerden prestijli firmalara
              kompresör çözümleri sunmuş bulunuyoruz.
            </p>
            <div className="references-grid">
              {references.map((reference, index) => (
                <ScrollAnimation key={index} direction="up" delay={index * 50}>
                  <div className="reference-card">
                    <div className="reference-logo">
                      <span className="reference-initials">
                        {reference.initials}
                      </span>
                    </div>
                    <h3 className="reference-name">{reference.name}</h3>
                    <p className="reference-sector">{reference.sector}</p>
                  </div>
                </ScrollAnimation>
              ))}
            </div>
          </section>

          <section className="quality-section">
            <div className="quality-content">
              <div className="quality-text">
                <h2>Kalite Politikamız</h2>
                <p>
                  RPM Kompresör olarak, müşteri memnuniyetini her şeyin üstünde
                  tutuyoruz. Kalite politikamız, sürekli iyileştirme ve müşteri
                  odaklı yaklaşım üzerine kuruludur.
                </p>
                <ul className="quality-points">
                  <li>Müşteri ihtiyaçlarını tam olarak anlama</li>
                  <li>Sürekli kalite iyileştirme</li>
                  <li>Çevre dostu çözümler</li>
                  <li>İş güvenliği önceliği</li>
                  <li>Teknolojik yenilik takibi</li>
                </ul>
              </div>
              <div className="quality-image">
                <div className="image-placeholder">
                  <span className="icon">🏆</span>
                  <p>Kalite Politikamız </p>
                </div>
              </div>
            </div>
          </section>

          <section className="contact-cta">
            <div className="cta-content">
              <h2>Kurumsal İhtiyaçlarınız İçin Bizimle İletişime Geçin</h2>
              <p>
                Büyük ölçekli projeleriniz için özel çözümler sunuyoruz.
                Kurumsal müşterilerimize özel fiyatlandırma ve hizmet paketleri.
              </p>
              <div className="cta-buttons">
                <Link to="/iletisim" className="btn btn-primary">
                  Kurumsal Teklif Al
                </Link>
                <a href="tel:+905342137564" className="btn btn-primary">
                  Hemen Ara
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Corporate;
